import { createRouter, createWebHistory } from 'vue-router'

const routes = [
	{
		path: '/',
		redirect: '/business'
	},
	{
		path: '/business',
		name: 'business',
		component: () => import('@/modules/business/index.vue')
	},
	{
		path: '/app',
		name: 'app',
		component: () => import('@/modules/app/index.vue')
	},
	{
		path: '/calloutLine',
		name: 'calloutLine',
		component: () => import('@/modules/calloutLine/index.vue')
	},
	{
		path: '/role',
		name: 'role',
		component: () => import('@/modules/role/index.vue')
	},
	{
		path: '/menu',
		name: 'menu',
		component: () => import('@/modules/menu/index.vue')
	},
	{
		path: '/version',
		name: 'version',
		component: () => import('@/modules/version/index.vue')
	},
	{
		path: '/packages',
		name: 'packages',
		component: () => import('@/modules/packages/index.vue')
	},
	{
		path: '/msgauditApply',
		name: 'msgauditApply',
		component: () => import('@/modules/msgauditApply/index.vue')
	},
	{
		path: '/login',
		name: 'login',
		component: () => import('@/modules/login/index.vue')
	},
	{
		path: '/statistics',
		name: 'statistics',
		component: () => import('@/modules/bugsStatistics/index.vue')
	},
	{
		path: '/shopManage',
		name: 'shopManage',
		redirect: '/shopManage/draftManage',
		component: () => import('@/modules/shopManage/index.vue'),
		children: [
			{
				path: 'draftManage',
				name: 'draftManage',
				component: () => import('@/modules/shopManage/draftManage.vue')
			},
			{
				path: 'templateManage',
				name: 'templateManage',
				component: () => import('@/modules/shopManage/templateManage.vue')
			},
			{
				path: 'versionManage',
				name: 'versionManage',
				component: () => import('@/modules/shopManage/versionManage.vue')
			},
		]
	}
]

export default createRouter({
	history: createWebHistory(),
	routes
})
